import type { ReactNode } from "react";
import { observer } from "mobx-react-lite";
import type { AccountDataScope } from "./AccountDataScope";
import { MyBenefitsPanel } from "./MyBenefitsPanel";
import "./AccountPage.css";

type Props = {
  scope: AccountDataScope;
  topBar: ReactNode;
  fixedTopBar?: boolean;
};

function CustomerBenefitsPage(props: Props): JSX.Element {
  const { scope, topBar, fixedTopBar = false } = props;
  const mainClass = fixedTopBar
    ? "customer-account-page__main customer-account-page__main--below-fixed-top"
    : "customer-account-page__main";
  return (
    <div className="customer-account-page">
      {topBar}
      <main className={mainClass}>
        <div className="customer-account-page__inner">
          <div className="customer-account-page__card">
            <h1 className="customer-account-page__title">我的权益</h1>
            <MyBenefitsPanel scope={scope} />
          </div>
        </div>
      </main>
    </div>
  );
}

export default observer(CustomerBenefitsPage);
